exports.install = function (Vue) {
  Vue.prototype.detection = function (params, length, str = "") {
    // params = params || '';
    // params= params.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");

    var regEn = /[*<>|?:.\/[\]]/im;
    // regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
    var next = true
    if (params == "") {
      this.$message.closeAll();
      this.$message({
        message: "名称不能为空",
        type: "warning"
      });
      // next = false
      return false
    }
    if (regEn.test(params)) {
      this.$message.closeAll();
      this.$message({
        message: "暂不支持特殊字符，请重新输入",
        type: "warning"
      });
      return false
    }
    if (params.length > (length || 16)) {
      this.$message.closeAll();

      this.$message({
        message: `${str}长度不能超过${length || 16}个字符`,
        type: "warning"
      });
      return false
    }
    return next
  }
  Vue.prototype.dateReg = function (params) { //日期正则
    var reg = /(\d{4}-\d{2}-\d{2})/;
    return reg.exec(params)[1];

  };
  Vue.prototype.nameReg = function (params) {
    var reg = /([^\.\/\\]+)\.([a-z]+)$/i; // 匹配拿到前缀（name）
    var resultArr = reg.exec(params);
    return resultArr[1];
  };
  Vue.prototype.typeReg = function (params) {
    var reg = /\.\w+$/; // 匹配拿到后缀
    var resultArr = reg.exec(params);
    return resultArr[0].slice(1)
  };
  Vue.prototype.transformDateFormat = function (params) {
    let da = new Date(params);
    let year = da.getFullYear();
    let month = da.getMonth() + 1;
    let date = da.getDate();
    return [year, month, date].join('-');
  };
  

  // 数组删除的方法 用法 ary.remove("要删除的元素")
  Array.prototype.indexOf = function (val) {
    for (var i = 0; i < this.length; i++) {
      if (this[i] == val) return i;
    }
    return -1;
  };
  Array.prototype.remove = function (val) {
    var index = this.indexOf(val);
    if (index > -1) {
      this.splice(index, 1);
    }
  };

};